{
  "close": "Bezárás",
  "notifications": "Értesítések"
}
